import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../../../components/AdminModal';
import useToast from '../../../../../customHooks/useToast';
import { ACTIVATE_AND_DEACTIVATE_STAFF } from '../../../../../graphql/admin_mutations';
import CircleCheckIcon from '../../../../../svgs/CircleCheckIcon';
import Styles from './ActivateMember.module.scss';

interface IActivateRole{
  onClose:any;
  payload:any;
  refetch:any;
}
const ActivateMember = ({ onClose, payload, refetch }:IActivateRole) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [activate, { loading: activateLoading }] = useMutation<
  { modifyAdminStatus: any },
  any
>(ACTIVATE_AND_DEACTIVATE_STAFF);

  const activateAndDeactivateRole = async () => {
    const data = { adminId: payload?.id, status: 'active' };
    if (!activateLoading) {
      try {
        const res = await activate({
          variables: data,
        });

        if (res?.data?.modifyAdminStatus && res?.data?.modifyAdminStatus?.status === 200) {
          refetch?.();
          setIsSuccessful(true);
        } else {
          Toast.error(res?.data?.modifyAdminStatus?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };
  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Member Activated!' : 'Are you sure you want to activate this member?'}
        subText={isSuccessful ? `${payload?.name} has been activated successfully.` : 'By clicking on “Activate”, you are accepting to reactivate this member by making it accessible in the system. If you are not sure, please cancel.'}
        actionBtnName="activate"
        handleModalAction={activateAndDeactivateRole}
        topIcon={<div className={Styles.wrapper__icon}><CircleCheckIcon /></div>}
        isShow
        isActionBtnDisabled={activateLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={activateLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      />
    </div>
  );
};

export default ActivateMember;
